import React from 'react';
import GoalChart from '../../components/TimeSheet/GoalChart';
import { Card } from 'react-bootstrap';
import CardHeader from '../../components/CardHeader';
import { useTranslation } from 'react-i18next';
import { TimeSheet } from './types';

type Props = {
  timeSheet: TimeSheet;
};

const GoalChartCard: React.FC<Props> = ({ timeSheet }) => {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader>{t('timeTracking.graphs.goal.title')}</CardHeader>
      <Card.Body>
        <GoalChart timeSheet={timeSheet} />
      </Card.Body>
    </Card>
  );
};

export default GoalChartCard;
